import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// English
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enDashboard from './locales/en/dashboard.json';
import enConferences from './locales/en/conferences.json';
import enSubmissions from './locales/en/submissions.json';
import enReviews from './locales/en/reviews.json';
import enAdmin from './locales/en/admin.json';
import enNotifications from './locales/en/notifications.json';
import enDecisions from './locales/en/decisions.json';
import enBilling from './locales/en/billing.json';

// French
import frCommon from './locales/fr/common.json';
import frAuth from './locales/fr/auth.json';
import frDashboard from './locales/fr/dashboard.json';
import frConferences from './locales/fr/conferences.json';
import frSubmissions from './locales/fr/submissions.json';
import frReviews from './locales/fr/reviews.json';
import frAdmin from './locales/fr/admin.json';
import frNotifications from './locales/fr/notifications.json';
import frDecisions from './locales/fr/decisions.json';
import frBilling from './locales/fr/billing.json';

// Arabic
import arCommon from './locales/ar/common.json';
import arAuth from './locales/ar/auth.json';
import arDashboard from './locales/ar/dashboard.json';
import arConferences from './locales/ar/conferences.json';
import arSubmissions from './locales/ar/submissions.json';
import arReviews from './locales/ar/reviews.json';
import arAdmin from './locales/ar/admin.json';
import arNotifications from './locales/ar/notifications.json';
import arDecisions from './locales/ar/decisions.json';
import arBilling from './locales/ar/billing.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon, auth: enAuth, dashboard: enDashboard,
        conferences: enConferences, submissions: enSubmissions, reviews: enReviews,
        admin: enAdmin, notifications: enNotifications, decisions: enDecisions,
        billing: enBilling,
      },
      fr: {
        common: frCommon, auth: frAuth, dashboard: frDashboard,
        conferences: frConferences, submissions: frSubmissions, reviews: frReviews,
        admin: frAdmin, notifications: frNotifications, decisions: frDecisions,
        billing: frBilling,
      },
      ar: {
        common: arCommon, auth: arAuth, dashboard: arDashboard,
        conferences: arConferences, submissions: arSubmissions, reviews: arReviews,
        admin: arAdmin, notifications: arNotifications, decisions: arDecisions,
        billing: arBilling,
      },
    },
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'auth', 'dashboard', 'conferences', 'submissions', 'reviews', 'admin', 'notifications', 'decisions', 'billing'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'locale',
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
